import React, { useState } from 'react';
import { TextField, IconButton, InputAdornment } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import './Password.css';

interface PasswordFieldProps {
  label?: string;
  value: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  error?: boolean;
  helperText?: string;
  fullWidth?: boolean;
  required?: boolean;
  onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
  autoComplete?: string;
  [key: string]: any;
}

const PasswordField: React.FC<PasswordFieldProps> = ({
  label = 'Password',
  value,
  onChange,
  error = false,
  helperText = '',
  fullWidth = false,
  required = false,
  onBlur,
  autoComplete,
  ...props
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const handleToggleVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  return (
    <TextField
      type={showPassword ? 'text' : 'password'}
      label={label}
      value={value}
      onChange={onChange}
      error={error}
      helperText={helperText}
      fullWidth={fullWidth}
      required={required}
      onBlur={onBlur}
      autoComplete={autoComplete}
      {...props}
      sx={{
        '& label.Mui-focused': {
          color: '#1976d2',
        },
        '& .MuiInputLabel-asterisk': {
          color: 'red',
        },
      }}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              onClick={handleToggleVisibility}
              edge="end"
              aria-label={showPassword ? 'Hide password' : 'Show password'}
            >
              {showPassword ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          </InputAdornment>
        ),
        inputProps: {
          className: 'no-native-eye',
        },
      }}
    />
  );
};

export default PasswordField;
